import { useEffect, useState } from "react";

import { amendMention } from "@/api/endpoints/episodes";
import Button from "@/components/Button";
import { Textarea } from "@components/Field";
import Modal, {
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalHeader,
} from "@components/Modal";

const EditMentionModal = ({ show, onHide, mention, updateMention }) => {
  // states
  const [editedMentionText, setEditedMentionText] = useState(
    mention.text
      ? mention.text.replace("…", "") // v4
      : mention.content.replace("…", "") // v1
  );

  useEffect(() => {
    setEditedMentionText(mention.text ? mention.text : mention.content);
  }, [mention]);

  const submit = (e) => {
    onHide();
    e.preventDefault();
    amendMention(mention.public_id, { mention_text: editedMentionText })
      .then((response) => {
        updateMention(response.data);
      })
      .catch(() => {
        // do nothing?
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader>
        <ModalDescription>
          {`${L.MENTIONS_EDIT_EDITING} ${mention.episode_title}`}
        </ModalDescription>
      </ModalHeader>
      <ModalContent>
        <Textarea
          value={editedMentionText}
          onChange={(e) => setEditedMentionText(e.target.value)}
          data-testid="mention-content-edit"
        />
      </ModalContent>
      <ModalFooter>
        <Button variant="secondary" onClick={onHide}>
          {L.MENTIONS_EDIT_BAR_CANCEL}
        </Button>
        <Button onClick={submit} data-testid="save-edit-button">
          {L.MENTIONS_EDIT_BAR_SAVE}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditMentionModal;
